import { PRESCRIPTION_TYPE_NO_PRESCRIPTION } from 'shared/consts/productTemplates'
import {
  RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED,
  VARIANT_ATTRIBUTES,
} from 'shared/experiments/consts'
import { isExperimentVariableTrue } from 'shared/experiments/utils/featureFlags'
import store from 'shared/store'
import { SELECT_ELEMENT } from 'views/assets/scripts/select'
import { CLIENTSIDE_HOOK_CHILDREN_WRAPPER } from 'views/containers/browser/ProductVariantsAttributesContainer/AttributePickers/AttributePickerRegionCollapsibleWrapper'

const VARIANT_ATTRIBUTES_BUTTON = '[name="variantAttribute"]'
const BUY_BOX_STICKY = '[data-clientside-hook="buy-box-sticky"]'
const PRESCRIPTION_SELECT = '[data-clientside-hook="h-ProductVariants-trigger"]'
const VARIANT_ATTRIBUTES_COLLAPSIBLE =
  '[data-clientside-hook="attributePicker-collapsible--label"]'

export default async () => {
  const {
    pageProperties: { experiments = [] },
  } = store.getPublicRuntimeConfig()

  const isVariantAttributeFlagSelected = isExperimentVariableTrue(
    VARIANT_ATTRIBUTES,
    RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED,
    experiments
  )

  isVariantAttributeFlagSelected && productVariantAttributesScript()
}

const productVariantAttributesScript = () => {
  const variantAttributesButtons = [
    ...document.querySelectorAll(VARIANT_ATTRIBUTES_BUTTON),
  ]

  const notepadIcon = document.querySelector(
    '[data-clientside-hook=o-BuyBoxWishList__listItem]'
  )
  const prescriptionSelect = document.querySelector(
    `${PRESCRIPTION_SELECT} ${SELECT_ELEMENT}`
  )

  prescriptionSelect?.addEventListener('change', event => {
    toggleAddToNotepadIcon(event)
  })

  const toggleAddToNotepadIcon = event => {
    if (event.currentTarget.value === PRESCRIPTION_TYPE_NO_PRESCRIPTION) {
      notepadIcon.classList.remove('o-BuyBoxIconList__item--hide')
    } else {
      notepadIcon.classList.add('o-BuyBoxIconList__item--hide')
    }
  }

  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  const isMaster = params.master

  const applyButtonWrapper = document.getElementById('applyButtonWrapper')
  const applyButton = document.getElementById('applyButtonOnPDP')
  const addToCartElement = document.getElementById('addToCardButton')
  const stockStatus = document.getElementById('stockStatus')
  const topOfPickers = document.getElementById('topOfPickers')

  const buyBoxSticky = document.querySelector(BUY_BOX_STICKY)

  const selectProductVariantButtonDrawer = document.getElementById(
    'selectProductVariantButtonDrawer'
  )
  const variantAttributesMessagesContainer = document.getElementById(
    'variantAttributesMessagesContainer'
  )

  const configureProductMessage = document.getElementById(
    'configureProductMessage'
  )
  const selectAllVariantAttributesMessage = document.getElementById(
    'selectAllVariantAttributesMessage'
  )
  const noCombinationAvailableOptionMessage = document.getElementById(
    'noCombinationAvailableOptionMessage'
  )

  const initialCollapsible = [
    ...document.querySelectorAll(VARIANT_ATTRIBUTES_COLLAPSIBLE),
  ]

  let selectedVariants = {}
  let allVariantAttributes = []

  /**
   * fetch product from page props
   */
  const product = store.getPublicRuntimeConfig().pageProperties.product

  /**
   * get all variant attributes for this product
   */
  product.variants.forEach(variant => {
    let currentVariant = {}
    variant.variantAttributes &&
      variant.variantAttributes.forEach(variantAttribute => {
        currentVariant[variantAttribute.variantCode] = variantAttribute.value
      })
    currentVariant['upid'] = variant.upid
    allVariantAttributes.push(currentVariant)
  })
  if (isMaster) {
    variantAttributesMessagesContainer.style.visibility = 'visible'
    configureProductMessage.style.display = 'flex'
    buyBoxSticky?.classList.add('o-BuyBoxSticky--incomplete')
  }

  /**
   * Function to create array with currently selected variant, so other could be selected on click
   */
  const preselectedVariantAttributes = () => {
    const currentVariantId = product.upid
    const currentVariant = product.variants.find(
      variant => variant.upid === currentVariantId
    )
    currentVariant?.variantAttributes.map(variantAttribute => {
      selectedVariants[variantAttribute.variantCode] = variantAttribute.value
    })
  }

  const applyStylesToCurrentPicker = event => {
    event.target.closest('button').className += ' selectedVariantAttribute'
    const circleBadgeSelector = event.target
      .closest('button')
      .querySelector('.a-CircleBadge')
    circleBadgeSelector?.classList.add('a-CircleBadge--border')
    const darkColorSelector = event.target
      .closest('button')
      .querySelector('.u-color--dark')
    darkColorSelector?.classList.add('a-ListPrice--color--background')
  }

  const areAllSelected = () => {
    const selectedVariantAttributes = document.querySelectorAll(
      `.o-ProductVariantsAttributePicker.selectedVariantAttribute`
    )
    let numberOfVariantAttributes = 0
    Object.keys(allVariantAttributes[0]).forEach(key => {
      if (key !== 'upid') {
        numberOfVariantAttributes++
      }
    })
    return selectedVariantAttributes.length === numberOfVariantAttributes
  }

  const isPossibleCombination = () => {
    return allVariantAttributes.some(variant => {
      selectedVariants['upid'] = variant['upid']
      return JSON.stringify(selectedVariants) == JSON.stringify(variant)
    })
  }
  const isSingleChangeableAttribute = () => {
    let numberOfMultipleValues = 0
    product.allAttributes.forEach(attribute => {
      if (attribute.values.length > 1) {
        numberOfMultipleValues++
      }
    })
    return numberOfMultipleValues < 2
  }

  const updateDomWithCurrentData = (event, parentDiv) => {
    stockStatus.hidden = true
    variantAttributesMessagesContainer.hidden = false
    const resetAttributes = [
      ...document.querySelectorAll('[id ="' + parentDiv + '"]'),
    ]

    if (!isSingleChangeableAttribute()) {
      buyBoxSticky?.classList.add('o-BuyBoxSticky--incomplete')

      addToCartElement.hidden = true
      applyButtonWrapper.hidden = false
    }

    selectedVariants[parentDiv] = null
    resetAttributes.forEach(ele => {
      ele.classList.remove('selectedVariantAttribute')
      const circleBadgeElement = ele.querySelector('.a-CircleBadge')
      circleBadgeElement?.classList.remove('a-CircleBadge--border')
      circleBadgeElement?.classList.add('a-CircleBadge--border--transparent')
      const darkColorSelector = ele.querySelector('.u-color--dark')
      darkColorSelector?.classList.remove('a-ListPrice--color--background')
    })

    selectedVariants[parentDiv] = event.currentTarget.value

    if (isPossibleCombination()) {
      applyButton.disabled = false
    }
    isSingleChangeableAttribute() && redirectToSelectedProduct()
  }

  const redirectToSelectedProduct = () => {
    const pathName = window.location.pathname
      .replace(/(^\/)|(\/$)/g, '')
      .split('/')
    window.location.href = `/${pathName[0]}/${selectedVariants['upid']}`
  }

  preselectedVariantAttributes()

  const displaySelectionError = () => {
    const attributePickers = document.querySelectorAll(`.attributePickers`)
    attributePickers.forEach(attributePicker => {
      if (
        attributePicker.querySelector(
          '.o-ProductVariantsAttributePicker.selectedVariantAttribute'
        ) === null
      ) {
        const errorAttributePickers = attributePicker.querySelectorAll(
          '.o-ProductVariantsAttributePicker'
        )
        errorAttributePickers.forEach(variantAttributeValue => {
          variantAttributeValue.classList.add('errorVariantAttribute')
        })
      }
    })
  }

  const hideSelectionError = () => {
    document
      .querySelectorAll(`.attributePickers .o-ProductVariantsAttributePicker`)
      .forEach(variantValue => {
        variantValue.classList.remove('errorVariantAttribute')
      })
  }
  const hideAllMessages = () => {
    configureProductMessage.style.display = 'none'
    selectAllVariantAttributesMessage.style.display = 'none'
    noCombinationAvailableOptionMessage.style.display = 'none'
  }

  const toggleErrorMessages = (applyClicked = false) => {
    if (isMaster) {
      if (areAllSelected()) {
        hideSelectionError()
        hideAllMessages()

        if (!isPossibleCombination() && applyClicked) {
          noCombinationAvailableOptionMessage.style.display = 'flex'
        } else {
          configureProductMessage.style.display = 'flex'
        }
      } else {
        hideAllMessages()
        if (applyClicked) {
          displaySelectionError()
          selectAllVariantAttributesMessage.style.display = 'flex'
        } else {
          hideSelectionError()
          configureProductMessage.style.display = 'flex'
        }
      }
    } else {
      variantAttributesMessagesContainer.style.visibility = 'visible'
      isPossibleCombination()
        ? hideAllMessages()
        : applyClicked &&
          (noCombinationAvailableOptionMessage.style.display = 'flex')
    }
  }

  const handlePickerClick = event => {
    let parentDiv = event.target.closest('button').id

    if (
      selectedVariants[parentDiv] === event.currentTarget.value &&
      areAllSelected()
    ) {
      return
    }

    updateDomWithCurrentData(event, parentDiv)
    applyStylesToCurrentPicker(event)

    areAllSelected() &&
      markNonExistingAndOutOfStockCombinations(
        product,
        selectedVariants,
        allVariantAttributes
      )
    toggleErrorMessages(false)
  }

  const toggleCollapsible = e => {
    const parent = e.target.closest('.attributeRegion')
    const clickedCollapsible = e.target.closest(
      '.o-ProductVariantsAttributePicker-Collapsible'
    )
    const variantWrapper = parent.querySelector(
      `[data-clientside-hook="${CLIENTSIDE_HOOK_CHILDREN_WRAPPER}"]`
    )

    if (clickedCollapsible.dataset.currentState === 'closed') {
      variantWrapper.classList.remove(
        'o-ProductVariantsAttributePicker-pill-teaser',
        'o-ProductVariantsAttributePicker-hide',
        'o-ProductVariantsAttributePicker-tile-teaser'
      )
      clickedCollapsible.dataset.currentState = ''
      clickedCollapsible.querySelector('svg').style.transform = 'rotate(180deg)'
      clickedCollapsible.querySelector('.m-TextWithIcon__text').innerHTML =
        clickedCollapsible.dataset.transClose
    } else {
      variantWrapper.classList.add('o-ProductVariantsAttributePicker-hide')
      clickedCollapsible.dataset.currentState = 'closed'
      clickedCollapsible.querySelector('svg').style.transform = 'none'
      clickedCollapsible.querySelector('.m-TextWithIcon__text').innerHTML =
        clickedCollapsible.dataset.transOpen
    }
  }
  const handleApplyButtonClick = () => {
    isPossibleCombination() && areAllSelected()
      ? redirectToSelectedProduct()
      : toggleErrorMessages(true)

    areAllSelected() &&
      markNonExistingAndOutOfStockCombinations(
        product,
        selectedVariants,
        allVariantAttributes
      )
  }

  initialCollapsible?.forEach(element =>
    element.addEventListener('click', e => {
      toggleCollapsible(e)
    })
  )

  variantAttributesButtons.forEach(button => {
    button.addEventListener('click', e => {
      handlePickerClick(e)
    })
  })
  applyButton?.addEventListener('click', () => {
    handleApplyButtonClick()
  })
  selectProductVariantButtonDrawer?.addEventListener('click', () => {
    window.scrollTo({
      top:
        topOfPickers.getBoundingClientRect().top +
        window.scrollY -
        document.getElementsByClassName('o-HeaderSmall__menu--noSearchBox')[0]
          ?.offsetHeight,
      behavior: 'smooth',
    })
  })
}

const markNonExistingAndOutOfStockCombinations = (
  product,
  selectedVariants,
  allVariantAttributes
) => {
  const buyableVariant = {}
  const notBuyableVariant = {}

  const availableVariants = product.variants.filter(variant => {
    return (
      variant.stockStatus?.statusReason === 'general.label.product.available'
    )
  })

  //add all variant options as grayedOut
  Object.keys(selectedVariants).forEach(key => {
    notBuyableVariant[key] = []
    allVariantAttributes.forEach(variant => {
      if (!notBuyableVariant[key].includes(variant[key])) {
        notBuyableVariant[key].push(variant[key])
      }
    })
  })

  //based on the current combination, calculate buyable variant values
  Object.keys(selectedVariants).forEach(key => {
    buyableVariant[key] = []
    const tempSelectedVariant = { ...selectedVariants }
    delete tempSelectedVariant['upid']
    availableVariants.forEach(availableVariant => {
      let exist = true
      let value = ''
      availableVariant.variantAttributes.forEach(availableVariantAttribute => {
        if (
          availableVariantAttribute.variantCode !== key &&
          tempSelectedVariant[availableVariantAttribute.variantCode] !==
            availableVariantAttribute.value
        ) {
          exist = false
        }
        if (availableVariantAttribute.variantCode === key) {
          value = availableVariantAttribute.value
        }
      })
      if (exist) {
        buyableVariant[key].push(value)
      }
    })
  })

  //remove grayedOut class from buyable
  for (const [key, value] of Object.entries(buyableVariant)) {
    value.forEach(singleBuyableVariant => {
      notBuyableVariant[key] = notBuyableVariant[key].filter(
        notBuyableVariant => notBuyableVariant !== singleBuyableVariant
      )
      const elements = document.querySelectorAll(
        `[data-qa-id="attributePicker-${key}"][value="${singleBuyableVariant}"]`
      )
      if (elements.length > 0) {
        elements[0].classList.remove('grayedOutVariantAttribute')
      }
    })
  }

  //add grayedOut class to notBuyable
  for (const [key, value] of Object.entries(notBuyableVariant)) {
    value.forEach(singleBuyableVariant => {
      notBuyableVariant[key] = notBuyableVariant[key].filter(
        notBuyableVariant => notBuyableVariant !== singleBuyableVariant
      )
      const elements = document.querySelectorAll(
        `[data-qa-id="attributePicker-${key}"][value="${singleBuyableVariant}"]`
      )
      if (elements.length > 0) {
        elements[0].classList.add('grayedOutVariantAttribute')
      }
    })
  }
}
